export const MOBILE_WIDTH = 991
